export const ASC = 'ascending';
export const DESC = 'descending';

// immuable
export const defaultArray = Object.freeze([]);
export const defaultObject = Object.freeze({});